import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/store'
import VueApollo from 'vue-apollo';
import {apolloClient} from "./plugins/apollo-client";
import Vuelidate from 'vuelidate'
import VTooltip from 'v-tooltip';
import * as VueGoogleMaps from 'vue2-google-maps'

import {} from '../src/services/fontAwesome'

Vue.use(VueApollo);
Vue.use(Vuelidate);
Vue.use(VTooltip);
Vue.use(VueGoogleMaps, {
    load: {
      key: 'AIzaSyAeN9iUHZ_1cO0KNmHT9TGaoPb-h3ivIrw',
      libraries: 'places',
    },
    installComponents: true
  }
)
const apolloProvider = new VueApollo({
  defaultClient: apolloClient,
});

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  apolloProvider,
  render: h => h(App)
}).$mount('#app');
